import React, { useRef, useState } from 'react';
import { Box, DateBox, Button } from 'devextreme-react';
import { Item } from "devextreme-react/box";

import Title from '../../components/shared/Title';
import BlockHeader from '../../components/shared/BlockHeader';

import { DataGrid } from 'devextreme-react';
import { Column, Export } from 'devextreme-react/data-grid';

import { _path } from "../../data/headerNavigation";
import { formatDate, resources } from '../../data/app';
import { formatToMoneyNumber } from '../../utils/common';

import http from '../../utils/http';
import { dateByReport, } from '../../data/defaultObjects';
import { userService } from '../../services/user.service';
import useAuthorization from '../../hooks/useAuthorization';

const ResultStete = (props) => {

    const user = userService.getUser();

    const [areaId] = useState(user.areaId);
    const [dateFrom, setDateFrom] = useState(dateByReport.from);
    const [dateTo, setDateTo] = useState(dateByReport.to);
    const [data, setData] = useState(undefined);
    const [loading, setLoading] = useState(false);
    const [exporting, setExporting] = useState(false);
    const [canSeeReport] = useAuthorization(resources.reporteEstadoResultados);

    let dataGrid = useRef();    

    const changeDateFrom = e => setDateFrom(e.value);

    const changeDateTo = e => setDateTo(e.value);

    const loadReport = () => {

        if (areaId > 0 && dateFrom && dateTo) {
            setLoading(true);
            http('reports/resultState').asPost({ areaId, productId: 0, from: dateFrom, to: dateTo, tipoFecha: 1, username: '' }).then(resp => {
                setData(resp);
                setLoading(false);
            });
        }

    };

    const exportReport = () => {

        if (!data) {
            console.error("No hay datos para exportar");
            return;
        }

        data.desde = dateFrom;
        data.hasta = dateTo;

        setExporting(true);
        const apiKey = "qX6+YYcK/yFrq30TES8pA2Oz7/L7Lhmv4chKkOOxz+Y="; // Reemplaza con tu API Key
        const reportName = "ReportEstadoResultado"; // Reemplaza con el nombre del reporte
        const source = {
            reportName: reportName,
            ApiKey: apiKey,
            Data: JSON.stringify([data]), // Reemplaza con los datos reales
            Parameters: {}//{ desde: dateFrom } // Reemplaza con los parámetros reales
        };

        // Construye la URL del endpoint
        const url = `https://design.quickreport.net/Report/GeneratePDFFromJson`;

        // Realiza la solicitud POST
        fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(source)
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error("Error al obtener el reporte PDF");
                }
                return response.json(); // Obtén la respuesta como JSON
            })
            .then(data => {
                console.log("URL del reporte:", data.url);
                window.open(data.url, '_blank'); // Abre el reporte en una nueva pestaña
            })
            .catch(error => {
                console.error("Error:", error);
            }).finally(() => {
                setExporting(false);
            });
    }

    const title = 'Estado de Resultados';

    const { ingresoVentasContado, ingresoVentasCredito, ingresoVentas, devoluciones, descuentos, ingresosNetos, costos, utilidadBruta, gastos, comissions, utilidadNeta } = data || {};

    const dataArrar = [ 
        { 'concepto': 'Ventas Contado', 'monto': ingresoVentasContado || 0 },
        { 'concepto': 'Ventas Credito', 'monto': ingresoVentasCredito || 0 },
        { 'concepto': 'Ingreso por ventas', 'monto': ingresoVentas || 0 },
        { 'concepto': '(-) Devoluciones', 'monto': devoluciones || 0, 'className': 'text-danger' },
        { 'concepto': '(-) Descuentos', 'monto': descuentos || 0, 'className': 'text-danger' },
        { 'concepto': '=Ingreso Neto', 'monto': ingresosNetos || 0, 'className': 'text-bold' },
        { 'concepto': '(-) Costos', 'monto': costos || 0, 'className': 'text-danger' },
        { 'concepto': 'Utilidad Bruta', 'monto': utilidadBruta || 0, 'className': 'text-bold' },
        { 'concepto': '(-) Gastos', 'monto': gastos || 0, 'className': 'text-danger' },
        { 'concepto': '(-) Comisiones', 'monto': comissions || 0, 'className': 'text-danger' },
        { 'concepto': 'Utilidad Neta', 'monto': utilidadNeta || 0, 'className': 'text-bold' }
    ];

    const onRowPrepared = (e) => {
        if (e.rowType == 'data') {
            if (e.data.concepto == '=Ingreso Neto' || e.data.concepto == 'Utilidad Bruta' || e.data.concepto == 'Utilidad Neta') {
                e.rowElement.classList.add('txt-bold');
            }

            if (e.data.className) {
                e.rowElement.classList.add(e.data.className);
            }
        }
    }

    return canSeeReport(
        <div className="container medium">

            <Title title={title} />
            <BlockHeader title={title} showFavorite={true} {...props}>
            </BlockHeader>

            <DataGrid visible={false}
                ref={dataGrid}
                selection={{ mode: 'single' }}
                dataSource={dataArrar}
                showBorders={true}
                showRowLines={true}
                hoverStateEnabled={true}
                onRowPrepared={onRowPrepared}
            >

                <Export enabled={true} fileName={title} allowExportSelectedData={true} />
                <Column dataField="concepto" caption="CONCEPTO" width={300}  />
                <Column dataField="monto" caption="MONTO NIO" width={150} alignment="right" />
            </DataGrid>

            <Box direction="row" width="100%" height={75}>
                <Item ratio={1} />
                <Item ratio={1}>
                    <div className="ml-10">
                        <label>Desde:</label>
                        <DateBox type="date"
                            value={dateFrom}
                            displayFormat={formatDate}
                            openOnFieldClick={true}
                            onValueChanged={changeDateFrom} />
                    </div>
                </Item>
                <Item ratio={1}>
                    <div className="ml-10">
                        <label>Hasta:</label>
                        <DateBox type="date"
                            value={dateTo}
                            displayFormat={formatDate}
                            openOnFieldClick={true}
                            onValueChanged={changeDateTo} />
                    </div>
                </Item>
                <Item ratio={1}>
                    <div style={{ paddingTop: '19px' }}>
                        <Button
                            width={140}
                            text={`${loading ? 'Buscando...' : 'Buscar'}`}
                            type="default"
                            icon="search"
                            stylingMode="contained"
                            className="m-1"
                            disabled={loading}
                            onClick={loadReport}
                        />
                    </div>
                </Item>
                <Item ratio={1}>
                    <div style={{ paddingTop: '19px' }}>
                        <Button
                            width={150}
                            text={`${exporting ? 'Exporando...' : 'Exportar PDF'}`}
                            type="normal"
                            icon="file"
                            stylingMode="contained"
                            className="m-1"
                            disabled={exporting || !data}
                            onClick={exportReport}
                        />
                    </div>
                </Item>
                <Item ratio={1}>
                    <div style={{ paddingTop: '19px' }}>
                        <Button
                            width={160}
                            text={`${exporting ? 'Exporando...' : 'Exportar Excel'}`}
                            type="normal"
                            icon="file"
                            stylingMode="contained"
                            className="m-1"
                            disabled={exporting || !data}
                            onClick={() => dataGrid.current.instance.exportToExcel(false)}
                        />
                    </div>
                </Item>
            </Box>
            <Box direction="row" width="100%" height={75}>
                <Item ratio={1} />
                <Item ratio={4}>
                    <table className="table table-hover">
                        <thead >
                            <tr>
                                <td className='text-bold'>CONCEPTO</td>
                                <td className='text-bold' align='right'>MONTO NIO</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Ventas Contado</td>
                                <td align='right'>{ingresoVentasContado ? formatToMoneyNumber(ingresoVentasContado) : 0}</td>
                            </tr>
                            <tr>
                                <td >Ventas Credito</td>
                                <td align='right'>{ingresoVentasCredito ? formatToMoneyNumber(ingresoVentasCredito) : 0}</td>
                            </tr>
                            <tr>
                                <td>Ingreso por ventas</td>
                                <td align='right'>{ingresoVentas ? formatToMoneyNumber(ingresoVentas) : 0}</td>
                            </tr>
                            <tr>
                                <td>(-) Devoluciones</td>
                                <td align='right' className=' text-danger'>{devoluciones ? formatToMoneyNumber(devoluciones) : 0}</td>
                            </tr>
                            <tr>
                                <td>(-) Descuentos</td>
                                <td align='right' className=' text-danger'>{descuentos ? formatToMoneyNumber(descuentos) : 0}</td>
                            </tr>
                            <tr>
                                <td className='text-bold'>= Ingreso Neto</td>
                                <td className='text-bold' align='right'>{ingresosNetos ? formatToMoneyNumber(ingresosNetos) : 0}</td>
                            </tr>
                            <tr>
                                <td>(-) Costos</td>
                                <td align='right' className=' text-danger'>{costos ? formatToMoneyNumber(costos) : 0}</td>
                            </tr>
                            <tr>
                                <td className='text-bold'>Utilidad Bruta</td>
                                <td className='text-bold' align='right'>{utilidadBruta ? formatToMoneyNumber(utilidadBruta) : 0}</td>
                            </tr>
                            <tr>
                                <td>(-) Gastos</td>
                                <td align='right' className=' text-danger'>{gastos ? formatToMoneyNumber(gastos) : 0}</td>
                            </tr>
                            <tr>
                                <td>(-) Comisiones</td>
                                <td align='right' className=' text-danger'>{comissions ? formatToMoneyNumber(comissions) : 0}</td>
                            </tr>
                            <tr>
                                <td className='text-bold'>Utilidad Neta</td>
                                <td align='right' className='text-bold'>{utilidadNeta ? formatToMoneyNumber(utilidadNeta) : 0}</td>
                            </tr>

                        </tbody>
                    </table>
                </Item>
                <Item ratio={1} />
            </Box>
        </div>
    );
}



export default ResultStete;
